<span class="notification__blue-text">&#64; {{ 'mentioned' | ppTranslate }} </span>
{{ 'you_in_a' | ppTranslate }}
<span class="notification__bold">{{ 'comment' | ppTranslate }}</span
>:
